import React from 'react';
import { Modal, Button } from 'antd';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { styles, createModalTitle } from '../ReconnectionModal.styles';

const HardReconnectionModal = ({ visible, onReconnect }) => {
  const { t } = useTranslation('modal');

  return (
    <Modal
      title={createModalTitle(t('reconnection.failed_title'))}
      open={visible}
      closable={false}
      centered
      footer={
        <div style={styles.modalFooter}>
          <Button
            key="refresh"
            type="primary"
            size="large"
            onClick={onReconnect}
            icon={
              <RefreshCw
                size={16}
                style={{ marginRight: '8px' }}
              />
            }
          >
            {t('reconnection.reconnect_button')}
          </Button>
        </div>
      }
    >
      <div style={styles.modalContent}>
        <div style={styles.iconContainer}>
          <AlertTriangle
            size={48}
            style={{ color: '#666' }}
          />
        </div>
        <p style={styles.description}>{t('reconnection.description')}</p>
        <p style={styles.instruction}>{t('reconnection.instruction')}</p>
      </div>
    </Modal>
  );
};

export default HardReconnectionModal;
